import React from 'react';
import styled, { css } from 'styled-components';
import { Skeleton } from 'fpay-ui';

const Layout = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    ${theme.breakpoint('md')} {
      margin-top: 55px;
    }
  `
);

const BoxDoFundsOut = styled.div(
  ({ theme }) => css`
    background-color: #fff;
    border-radius: 6px;
    width: 100%;
    padding-top: 37px;
    padding-bottom: 32px;
    padding-left: 32px;
    text-align: left;
    max-width: 500px;
    ${theme.breakpoint('md')} {
      padding-top: 32px;
      padding-bottom: 38px;
    }
  `
);

const BoxBank = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    background-color: #fff;
    border-radius: 6px;
    width: 100%;
    padding-top: 24px;
    padding-bottom: 29px;
    text-align: left;
    padding-left: 22px;
    max-width: 500px;
    ${theme.breakpoint('md')} {
      padding-top: 31px;
      padding-bottom: 33px;
      padding-left: 32px;
    }
  `
);

const BoxDoFundsOutLayoutSalesLarge = styled.div`
  margin-top: 25px;
`;

const BoxDoFundsOutLayoutSalesLeft = styled.div`
  margin-top: 25px;
  text-align: right;
  padding-right: 32px;  
`;

const SkeletonIcon = styled(Skeleton)`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin-left: 5px;
`;

const SkeletonTitle = styled(Skeleton)`
  width: 104px;
  height: 22px;
`;

const SkeletonTitlesDoFundsOut = styled(Skeleton)(
  ({ theme }) => css`
    display: flex;
    width: ${(props) => (props.large ? '251px' : props.medium ? '183px' : '104px')};
    height: 20px;
    margin-top: ${(props) => (props.large ? '0px' : props.medium ? '4px' : '4px')};
    ${theme.breakpoint('md')} {
      display: ${(props) => (props.large ? 'flex' : props.medium ? 'flex' : 'none')};
      height: 22px;
      width: ${(props) => (props.large ? '311px' : props.medium ? '184px' : 'none')};
    }
  `
);

const SkeletonFounds = styled(Skeleton)(
  ({ theme }) => css`
    width: ${(props) => (props.large ? '251px' : props.medium ? '183px' : '104px')};
    height: ${(props) => (props.large ? '42px' : '25px')};
    margin-top: 25px;
    ${theme.breakpoint('md')} {
      width: ${(props) => (props.large ? '311px' : props.medium ? '184px' : 'none')};      
      height: ${(props) => (props.large ? '45px' : '35px')};
      margin-top: 25px;
    }
  `
);

const SkeletonButton = styled(Skeleton)`
  width: 134px;
  height: 40px;
  margin-left: 20px;
`;

const SkeletonTitlesBank = styled(Skeleton)(
  ({ theme }) => css`
    display: flex;
    width: ${(props) => (props.large ? '251px' : props.medium ? '183px' : '104px')};
    height: 20px;
    margin-top: ${(props) => (props.large ? '0px' : props.medium ? '4px' : '4px')};
    ${theme.breakpoint('md')} {
      display: ${(props) => (props.large ? 'flex' : props.medium ? 'flex' : 'none')};
      height: 22px;
      width: ${(props) => (props.large ? '311px' : props.medium ? '184px' : 'none')};      
    }
  `
);

const SkeletonDoFoundsOut = () => {
  return (
    <Layout>
      <BoxDoFundsOut>
        <SkeletonTitlesDoFundsOut medium />
        <BoxDoFundsOutLayoutSalesLarge>
          <SkeletonTitlesDoFundsOut large />
        </BoxDoFundsOutLayoutSalesLarge>                
        <BoxDoFundsOutLayoutSalesLarge>
          <SkeletonFounds large />
        </BoxDoFundsOutLayoutSalesLarge>
        <BoxDoFundsOutLayoutSalesLarge>
          <SkeletonTitle />
          <SkeletonIcon />
        </BoxDoFundsOutLayoutSalesLarge>
        <BoxDoFundsOutLayoutSalesLeft>
          <SkeletonButton />
          <SkeletonButton />
        </BoxDoFundsOutLayoutSalesLeft>        
      </BoxDoFundsOut>
      <BoxBank>
        <SkeletonTitlesBank large />
        <SkeletonTitlesBank />
        <SkeletonTitlesBank medium />
      </BoxBank>
    </Layout>
  );
};

export default SkeletonDoFoundsOut;
